import { iconChevronSmall180 } from '@tesla/design-system-icons';
import cx from 'classnames';
import React, { useMemo, useRef } from 'react';
import { useId } from '../hooks/use-id.js';
import { Icon } from '../icon/index.js';
export const FormInputSelect = ({ children, className, disabled, id, inputRef, leading, nullOptionsLabel = 'Select', options, readOnly, selectOnFocus, trailing, variant = 'default', value, ...rest }) => {
    const uId = useId();
    const htmlId = id || uId;
    const willSelectOnFocus = selectOnFocus !== null && selectOnFocus !== void 0 ? selectOnFocus : readOnly;
    const fallbackRef = useRef(null);
    const ref = inputRef || fallbackRef;
    // Add a fallback in case no options passed
    if (!children && (!options || !options.length)) {
        options = [{ label: nullOptionsLabel, value: '' }];
    }
    const formattedOptions = useMemo(() => {
        return options === null || options === void 0 ? void 0 : options.map((opt) => (typeof opt === 'string' ? { value: opt, label: opt } : opt));
    }, [options]);
    return (React.createElement("div", { className: cx('tds-form-input', {
            [`tds-form-input--${variant}`]: variant,
            'tds-form-input--readonly': readOnly,
            'tds--disabled': disabled,
        }, className), onClick: (e) => {
            var _a, _b, _c;
            // Autofocus select/input when outer div is clicked
            if (!e.target.closest('button, .tds-tooltip-wrapper') ||
                willSelectOnFocus) {
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
                // Auto-select text within the input when focused
                if (willSelectOnFocus && !((_b = document.getSelection()) === null || _b === void 0 ? void 0 : _b.toString().length)) {
                    (_c = ref.current) === null || _c === void 0 ? void 0 : _c.select();
                }
            }
        } },
        leading && React.createElement("div", { className: "tds-form-input-leading" }, leading),
        !readOnly ? (React.createElement("select", { className: "tds-form-input-select", id: htmlId, 
            // @ts-expect-error - select|input ref type is the same in practical use, but different in TS
            ref: ref, readOnly: readOnly, value: value, disabled: disabled, ...rest }, children ||
            (formattedOptions === null || formattedOptions === void 0 ? void 0 : formattedOptions.map((option) => (React.createElement("option", { key: String(option.value), ...option }, option.label)))))) : (React.createElement("input", { 
            // Replicate a select visually with a text input so that `readOnly` may be applied
            className: "tds-form-input-select", id: htmlId, readOnly: readOnly, value: value, 
            // @ts-expect-error - select|input ref type is the same in practical use, but different in TS
            ref: ref, ...rest })),
        React.createElement("div", { className: "tds-form-input-trailing" },
            trailing,
            !readOnly && React.createElement(Icon, { data: iconChevronSmall180 }))));
};
